import { render, staticRenderFns } from "./ProductRadioPrice.vue?vue&type=template&id=6129421d"
import script from "./ProductRadioPrice.vue?vue&type=script&lang=ts"
export * from "./ProductRadioPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports